import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from 'sonner';
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Services from './components/Services';
import Trainers from './components/Trainers';
import InstagramReels from './components/InstagramReels';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ParticleBackground from './components/ParticleBackground';
import useScrollReveal from './hooks/useScrollReveal';

function App() {
  useScrollReveal();

  // Parallax effect
  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.pageYOffset;
      const parallaxElements = document.querySelectorAll('.parallax-slow');
      
      parallaxElements.forEach(el => {
        const speed = el.dataset.speed || 0.5;
        el.style.setProperty('--scroll-offset', `${scrolled * speed}px`);
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <BrowserRouter>
      <div className="App" dir="rtl">
        <ParticleBackground />
        <Navbar />
        <Hero />
        <Features />
        <Services />
        <Trainers />
        <InstagramReels />
        <Gallery />
        <Testimonials />
        <Contact />
        <Footer />
        <WhatsAppButton />
        <Toaster 
          position="top-center"
          toastOptions={{
            style: {
              background: '#1a1a1a',
              color: '#ffffff',
              border: '1px solid rgba(212, 165, 116, 0.3)',
            },
          }}
        />
      </div>
    </BrowserRouter>
  );
}

export default App;
